import React from 'react';
import { goodJob1Gif } from 'utils/assets/images';

// const ResponseText = styled.div`
//   margin-left: 20px;
// `;

const GoodJob = () => {
 
    return (
        <>
          <div className="goodjobpage">
            <img src="https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/debetlogoImage.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222" alt="Debate" className="debate1waysticker" />
          </div>
          <div className="goodjobbg">
            <img
              src={goodJob1Gif}
              alt="Debate"
              className="goodjobimage"
            />
          </div>
        </>
      );
    };

export default GoodJob;


